import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { goToLink } from "@actions/common";
import { useGetCasinoGamesInfiniteQuery } from "@api/thirdPartyIntegration";
import { showAlert as showAlertAction } from "@components/alert/action";
import { openGame } from "@pages/casino/utils";

const PAGE_SIZE = 42;

const selectCurrency = (state) => state.balance.currency || undefined;

const useController = () => {
	const [isToggled, setIsToggled] = useState(false);
	const [randomGame, setRandomGame] = useState(null);

	const currency = useSelector(selectCurrency);

	const {
		data: casino,
		isLoading,
		isFetching,
	} = useGetCasinoGamesInfiniteQuery(
		{
			size: PAGE_SIZE,
			currency: currency,
		},
		{ skip: !isToggled }
	);

	const casinoGames = casino?.pages?.[0]?.games || [];

	const dispatch = useDispatch();

	const redirect = useCallback(
		(...args) => {
			dispatch(goToLink(...args));
		},
		[goToLink]
	);

	const showAlert = useCallback(
		(...args) => {
			dispatch(showAlertAction(...args));
		},
		[showAlertAction]
	);

	const handleToggleChange = () => {
		setIsToggled((prev) => !prev);
	};

	const handleGameSelect = () => {
		if (!casinoGames?.length) return;

		setRandomGame(casinoGames[Math.floor(Math.random() * casinoGames?.length)]);
	};

	const handlePlayButtonClick = () => {
		openGame(randomGame, redirect, showAlert);
	};

	useEffect(() => {
		handleGameSelect();
	}, [casino]);

	return {
		state: {
			isToggled,
			randomGame,
			casinoGames,
			isLoading: isLoading || isFetching,
		},
		handlers: { handleToggleChange, handlePlayButtonClick, handleGameSelect },
	};
};

export default useController;
